export default function PageHeader({ eyebrow, title, subtitle, right, testId }) {
  return (
    <div className="mb-10 flex flex-wrap items-end justify-between gap-4 rise-in" data-testid={testId}>
      <div className="max-w-2xl">
        {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">{title}</h1>
        {subtitle && <p className="mt-4 text-base sm:text-lg text-ink-soft leading-relaxed">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}
